import { makeStyles } from 'tss-react/mui';

import { dFlex, scrollBar } from '@assets/mixins';

const useStyles = makeStyles()((theme) => ({
  modal: {
    ...dFlex('center', 'flex-start'),
    flexDirection: 'column',
    gap: 24,
    height: '100%',
  },
  headerModal: {
    ...dFlex(),
    gap: 8,
  },
  closeBtn: {
    ...dFlex(),

    '& svg': {
      width: 24,
    },
  },
  children: {
    height: '100%',
    width: '100%',
    marginTop: 'auto',
  },
  dialog: {
    height: 'calc(100% - 40px)',
    top: 'unset',

    '& .MuiDialog-paper': {
      background: theme.palette.custom.background.medium,
      padding: '16px 16px 40px 16px',
      borderRadius: '16px 16px 0px 0px',
      ...scrollBar,
    },

    '& .MuiModal-backdrop': {
      background: '#402C18B8',
    },
  },
}));

export default useStyles;
